import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TRAINING_NAME } from '../../common/constants.js';
import helpIcon from '../atoms/data/help-icon.svg';

const HeaderTraining = (props) => {
     const createProgressDots = (current) => {
        let ret = [];
        for(let i = 0; i < props.maxPage; i++){
            if(i === current){
                ret.push(
                    <Bar  key={i} color='#00b050'></Bar >
                );
            } else if(i < current){
                    ret.push(
                        <Bar  key={i} color='#c5e0b4'></Bar >
                    );
            } else {
                ret.push(
                    <Bar  key={i}></Bar >
                );
            }
        }

        return ret;
    }

    let helpCtrl;
    if(props.current === (props.maxPage - 1)) {
        // 日本語訳の確認画面はヘルプボタン不要
        helpCtrl = "";
    } else {
        helpCtrl = (
            <HelpButton onClick={() => props.onClickHelp()}>
                <img src={helpIcon} alt="img" width="32px" height="32px" />
            </HelpButton>
        );
    }

    const createHederHelp = (page) => {
        let hederHelp;
        if (page === 1) {
            hederHelp = (
                <HeaderHelp >
                    音声を<b>一度だけ</b>聞いて、内容をどのくらい理解できるか確認します。聞き終わったら<b>「わかったこと」を声に出して説明</b>してみましょう。この段階では全部わからなくても大丈夫です。
                </HeaderHelp>
            );
        }
        if (page === 2) {
            hederHelp = (
                <HeaderHelp>
                    音声に続いて<b>発音</b>しながら、<b>日本語の意味が瞬時に思い浮かぶ</b>ようになるまで繰り返し学習します。次に、日本語だけを表示させた状態で<b>英語を瞬時に言える</b>ようになるまで繰り返しましょう。
                </HeaderHelp>
            );
        }
        if (page === 3) {
            hederHelp = (
                <HeaderHelp>
                    チャンクごとに意味を確認したうえで、<b>内容が瞬時に思い浮かぶ</b>ようになるまで繰り返し音読します。その後、<b>サイトトランスレーション</b>や<b>Read and look-up</b>などに取り組みましょう。
                </HeaderHelp>
            );
        }
        if (page === 4) {
            hederHelp = (
                <HeaderHelp>
                    <b>音声を聞きながら1、2語遅れで発音</b>していきます。抑揚や音声変化なども再現しながら、最終的に<b>英文を見ずに内容をイメージしながらシャドーイング</b>できるようにしましょう。
                </HeaderHelp>
            );
        }
        if (page === 5) {
            hederHelp = (
                <HeaderHelp>
                    最後に改めて日本語訳に目を通します。内容の理解に間違いがあった場合は、前の画面に戻って英文をもう一度確認しましょう。これでトレーニングは終了です。お疲れさまでした！
                </HeaderHelp>
            );
        }
        return hederHelp;
    }

    return(
        <Body>
            <Bars>
                {createProgressDots(props.current)}
            </Bars>
            <HeaderInfo>
                <TrainingName>
                    {TRAINING_NAME[props.current + 2]}
                </TrainingName>
                {helpCtrl}
            </HeaderInfo>
                {createHederHelp(props.current + 1)}
        </Body>
    );
}

export { HeaderTraining };

HeaderTraining.propTypes = {
    current: PropTypes.number.isRequired,
    maxPage: PropTypes.number.isRequired,
    onClickMenu: PropTypes.func.isRequired,
};

const Body = styled.div`
    width: 100%;
    height: 110px;
    background-color: #F2F2F2;
    justify-content: space-between;
    align-items: center;
    font-size: 32px;

`;
const Bars = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;    
`;

const Bar = styled.p`
    margin: 10px 1px 3px 1px;
    width: 18%;
    height: 10px;
    background: ${props => (props.color ? props.color : '#bfbfbf')};
`;

const HeaderInfo = styled.div`
    display: flex;
    height: 38px
    margin: 0px 5px;
    width: 95%;
    display: flex;
    font-size: 24px;
    align-items: center;
`;

const TrainingName = styled.div`
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
`;

const HeaderHelp = styled.div`
    margin: 3px 5px;
    width: 95%;
    font-size: 12px;
    line-height: 1em;
`;

const HelpButton = styled.span`
    margin: 0px -35px;
    color: #F6D47E;
`;
